module.exports = __webpack_public_path__ + "img/ft_logo.b15a0aa3.png";